module.exports = __webpack_public_path__ + "img/homesol_6.57839a3a.png";